module.exports = __webpack_public_path__ + "media/categories/2036-5ac96ce6.svg";